import { z } from 'zod';

export const errorLogEntrySchema = z.object({
  message: z.string(),
  stack: z.string().optional(),
  timestamp: z.string(),
  url: z.string(),
  userAgent: z.string(),
  extra: z.record(z.string(), z.unknown()).optional(),
});

export const errorLogContextSchema = z.object({
  context: z.string().optional(),
  type: z
    .enum([
      'query',
      'mutation',
      'component',
      'global',
      'async',
      'manual',
      'unhandledRejection',
    ])
    .optional(),
  userId: z.string().optional(),
  sessionId: z.string().optional(),
  feature: z.string().optional(),
  operation: z.string().optional(),
  filename: z.string().optional(),
  lineno: z.number().optional(),
  colno: z.number().optional(),
  name: z.string().optional(),
  level: z.enum(['info', 'warning', 'error']).optional(),
  trigger: z.string().optional(),
  test: z.boolean().optional(),
  reason: z.unknown().optional(),
});

export const errorLogRequestSchema = z.object({
  message: z.string(),
  stack: z.string().optional(),
  extra: errorLogContextSchema.optional(),
});

export const errorMessageLevelSchema = z.enum(['info', 'warning', 'error']);

export type ErrorLogEntry = z.infer<typeof errorLogEntrySchema>;
export type ErrorLogContext = z.infer<typeof errorLogContextSchema>;
export type ErrorLogRequest = z.infer<typeof errorLogRequestSchema>;
export type ErrorMessageLevel = z.infer<typeof errorMessageLevelSchema>;
